import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { checkPermission } from "./validation";
const hasPermission = (user, account, roles, workspaceId) => (permission) => checkPermission(user, account, roles, permission, workspaceId);
const hasAnyPermission = (user, account, roles, workspaceId) => (...permissions) => {
    return permissions.some((permission) => checkPermission(user, account, roles, permission, workspaceId));
};
const hasAllPermissions = (user, account, roles, workspaceId) => (...permissions) => {
    return permissions.every((permission) => checkPermission(user, account, roles, permission, workspaceId));
};
export const PermissionsContext = createContext(null);
export function usePermissions() {
    return (useContext(PermissionsContext) ?? {
        hasPermission: () => false,
        hasAnyPermission: () => false,
        hasAllPermissions: () => false,
    });
}
export function PermissionsProvider({ user, account, roles, workspaceId, children, }) {
    let value = {
        hasPermission: hasPermission(user, account, roles, workspaceId),
        hasAnyPermission: hasAnyPermission(user, account, roles, workspaceId),
        hasAllPermissions: hasAllPermissions(user, account, roles, workspaceId),
    };
    return _jsx(PermissionsContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=react.js.map